document.addEventListener('DOMContentLoaded', () => {
  const contentful = require('contentful');
  const SPACE_ID = 'te7w479p763y';
  const ACCESS_TOKEN = 'FEIsFFwmX2tW-zEtqr2-pxJS0PTpzqXRqS9jp9YNhHQ';
  const downloadsSection = document.getElementById('xitavo-downloads');
  const downloadSvgIcon = `<svg viewBox="0 0 1 1" class="iconography" size="xxs" color="green"><use xlink:href="../assets/icons/icons.svg#download-arrow"></use></svg>`;
  const client = contentful.createClient({
    space: SPACE_ID,
    accessToken: ACCESS_TOKEN
  });

  function renderColumns(varieties) {
    const columnIds = [];
    const columnBuild = [];
    const firstColumn = `
      <div class="col-12 md:col-4 mb-3 download__col" id="info">
        <p class="font-normal mb-2">Download Xitavo<sup>&reg;</sup> soybean seed profiles to learn more about our products</p>
        <ul class="list-reset">
            <div class="btn__new mb-1"><span>New</span></div>
            <li class="pdf-download leading-tight">
              <span class="download__icon"></span>
              <a class="type__downloads download__link" target="_blank" href="#" data-contentful-pdf data-contentful-model-id="2y2fmszBz3oxj3pChGQD3L">
                Xitavo 2025 Soybean Products (PDF)
              </a>
            </li>
        </ul>
      </div>
    `;
    columnBuild.push(firstColumn);
    let groupIndex = 0;
    let groupPdfIds = [
      '2pZD92LoZIgivevybvaKZe',
      '6oP0WXOlbTn3gX02E8SFxj',
      '6xyxsXJjV2FUZRj37zZXQ9',
      '7Ckz4qDY1rY9NPt4NZIKMu',
      '63IZX1qya1gNNXuKA1qmya'
    ];

    varieties.forEach(function(variety) {
      const relativeMaturity = variety.fields.relativeMaturity;
      const maturityGroup = String(relativeMaturity).charAt(0);

      if (!columnIds.includes(maturityGroup)) {
        columnIds.push(maturityGroup);
        columnBuild.push(`
          <div class="col-12 md:col-4 mb-3 download__col" id="maturity-group-${maturityGroup}">
            <p class="font-normal mb-2">Maturity Group ${maturityGroup}</p>
            <ul class="list-reset pdf-download-list">
              <li class="leading-tight pdf-download mb-2">
                <span class="download__icon"></span>
                <a class="type__downloads download__link font-bold" target="_blank" href="#" data-contentful-pdf  data-contentful-model-id="${groupPdfIds[groupIndex]}">
                  Download All Maturity Group ${maturityGroup}
                </a>
              </li>
            </ul>
          </div>
        `);
        groupIndex++;
      }
    });
    return columnBuild.join('\n');
  }

  function populateDownloadCols(varieties) {
    varieties.forEach(function(variety) {
      const relativeMaturity = variety.fields.relativeMaturity;
      const maturityGroup = String(relativeMaturity).charAt(0);
      const currentDownloadCol = document.getElementById(`maturity-group-${maturityGroup}`);
      const currentDownloadlist = currentDownloadCol.querySelector('.pdf-download-list');
      const li = document.createElement('li');
      li.className = 'leading-tight pdf-download mb-1';
      const a = document.createElement('a');
      const span = document.createElement('span');
      span.className = 'download__icon';
      a.className = 'type__downloads download__link';
      a.href = variety.fields.profileSheet.fields.file.url;
      a.appendChild(document.createTextNode(`Xitavo Profile Sheet ${variety.fields.name} (PDF)`));
      li.appendChild(span);
      li.appendChild(a);
      currentDownloadlist.appendChild(li);
    });
  }

  if (downloadsSection) {
    client
      .getEntries({
        content_type: 'xitavoVarieties',
        order: 'fields.relativeMaturity,fields.name'
      })
      .then(response => {
        const varieties = response.items;
        const columnMarkup = renderColumns(varieties);
        downloadsSection.innerHTML = columnMarkup;
        populateDownloadCols(varieties);
        insertDownloadIcons();
      })
      .then(() => {
        setPDFDownloads();
        initDownloadAllBtns();
      });
  }

  function insertDownloadIcons() {
    var downloads = $('.download__icon');
    downloads.each((index, item) => {
      let download = $(item);
      download.html(downloadSvgIcon);
    });
  }

  function setPDFDownloads() {
    const pdfs = document.querySelectorAll('[data-contentful-pdf]');
    // Downloads Page => populate PDF anchor links with contentful urls
    if (pdfs) {
      pdfs.forEach(pdf => {
        const modelID = pdf.getAttribute('data-contentful-model-id');
        const assetID = pdf.getAttribute('data-contentful-asset-id');
        // If there is a model ID, we get the contentful varieties model and get the linked asset field: profileSheet
        if (modelID) {
          client.getEntry(modelID).then(function(entry) {
            let pdfUrl;
            if (entry.fields.profileSheet) {
              pdfUrl = entry.fields.profileSheet.fields.file.url;
            }
            if (entry.fields.catalog) {
              pdfUrl = entry.fields.catalog.fields.file.url;
            } else {
              console.log('Invalid Contentful model id');
              pdfUrl = '#';
            }
            pdf.setAttribute('href', pdfUrl);
          });
          // In case of a standalone PDF not associated with a model, we will get it using the contentful asset ID
        } else if (assetID) {
          client.getAsset(assetID).then(asset => {
            const assetFile = asset.fields.file;
            const assetURL = assetFile.url;
            pdf.setAttribute('href', assetURL);
          });
        }
      });
    }
  }

  function initDownloadAllBtns() {
    downloadsSection.addEventListener('click', e => {
      if (e.target.classList.contains('download__link-all')) {
        e.preventDefault();
        let downloadBtn = $(e.target);
        let pdfs = downloadBtn
          .parents('.download__col')
          .find('a.download__link')
          .not('.download__link-all');
        pdfs.each((index, item) => {
          let pdf = $(item);
          let url = pdf.attr('href');
          let a = document.createElement('a');
          let name = pdf.html();
          a.setAttribute('href', url);
          a.setAttribute('download', name.trim());
          a.setAttribute('target', '_blank');
          a.click();
          setTimeout(() => {
            a.remove();
          }, 100);
        });
      }
    });
  }
});
